<template>
  
  
  <div>


     <HeaderMain
      :hideOrderButton="true"
      title="Бонусы"
    /> 

  <!-- <div class="header-main ">
    <div class="hm-left ">
      <div>
        <div class="bread-crumb"></div>
        <div class="header-main__title-wrap"><h1 class="header-main__title">Бонусы</h1>
        <div class="header-main__review"></div>
        </div>
        </div>
      </div>

      <div class="hm-right">
        <div class="btn-wrapper btn-wrapper_group new">
          <router-link to="/tasksto" class="btn_ms m0 btn" v-if="$store.state.user.id === 14">
            <div class="">Задачи</div>
          </router-link>
          <router-link to="/alltask" class="btn_ms m0 btn btntask">
            <div class="">Задачи</div>
          </router-link>
          <router-link to="/orders" class="btn_ms btn">
            <div class="">Заказы</div>
          </router-link>
        <router-link to="/" class="btn_ms btn">
            <div class="">Товары</div>
          </router-link>             
        </div>
      </div>

    </div> -->

  

  <form class="filters" @submit.prevent="search" autocomplete="off">
    <div class="blockFlx">

      <div>
        <label for="phone">Телефон</label>
        <input v-model="filters.phone" placeholder="Телефон" class="input" />
      </div>
      <div>
        <label for="min">Мин. бонусов</label>
        <input v-model.number="filters.min_bonus" type="number" placeholder="Мин. бонусов" class="input" />
      </div>
      <div>
        <label for="max">Макс. бонусов</label>
        <input v-model.number="filters.max_bonus" type="number" placeholder="Макс. бонусов" class="input" />
      </div>


      <div class="input_flex">
        
        <span class="nLabel">Дата рассылки</span>
        <div style="display:inline-flex;margin: 0;">
        <date-picker
          v-model="filters.from"
          format="YYYY-MM-DD"
          input-class="mx-input"
          :placeholder="'От'"
          style="width:150px"
        />
        <span style="margin: 5px 5px;"> - </span>
        <date-picker
          v-model="filters.to"
          format="YYYY-MM-DD"
          input-class="mx-input"
          :placeholder="'До'"
          style="width:150px"
        />
        </div>

      </div>

      <div>
        <label class="statRas" for="stat">Статус рассылки</label>
          <select v-model="filters.mailing_sent" class="input" style="width:120px;">
            <option value="">Все рассылки</option>
            <option :value="1">Только отправленные</option>
            <option :value="0">Только неотправленные</option>
          </select>

      </div>

    
    </div>

    


    

      <div style="margin-bottom: 10px;float:right; position: relative;top: -25px;">
        <label>Показывать на странице: </label>
        <select v-model.number="limit" style="width:80px;">
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="500">500</option>
        </select>
      </div>




      <button type="submit" class="btn">Поиск</button>
      <button type="button" class="btn btn-clear" @click="resetFilters">Сбросить</button>
    </form>
    <table class="table">
<thead>
  <tr>
    <th v-if="$store.state.user.id === 162"><input type="checkbox" :checked="allSelected" @change="toggleAll" /></th>
    <th @click="setSort('phone')" :class="sortIcon('phone')">Телефон</th>
    <th @click="setSort('bonus')" :class="sortIcon('bonus')">Бонусы</th>
    <th @click="setSort('reserved')" :class="sortIcon('reserved')">Резерв</th>
    <th @click="setSort('last_bonus_at')" :class="sortIcon('last_bonus_at')">Дата последнего начисления</th>
    <th>ID заказа (начисление)</th>
    <th>Сумма (начисление)</th>
    <th @click="setSort('last_spend_at')" :class="sortIcon('last_spend_at')">Дата последнего списания</th>
    <th>ID заказа (списание)</th>
    <th>Сумма (списание)</th>
    <th @click="setSort('mailing_date')" :class="sortIcon('mailing_date')">Дата рассылки</th>
    <th @click="setSort('mailing_sent')" :class="sortIcon('mailing_sent')">Рассылка</th>
    <th>Сообщение</th>
    <th v-if="$store.state.user.id === 162">Редактирование</th>
  </tr>
</thead>
<tbody>
  <tr v-for="(acc, idx) in accounts" :key="acc.id">
    <td v-if="$store.state.user.id === 162"><input type="checkbox" :value="acc.phone" v-model="selectedPhones" /></td>
    <td>
      <span v-if="editIdx !== idx">{{ acc.phone }}</span>
      <input v-else v-model="editData.phone" class="input" style="width:120px;">
    </td>
    <td>
      <span v-if="editIdx !== idx">{{ acc.bonus }}</span>
      <input v-else v-model.number="editData.bonus" type="number" class="input" style="width:70px;">
    </td>
    <td>{{ acc.reserved }}</td>

    <!-- Дата последнего начисления -->
    <td>{{ acc.last_bonus_at ? formatDate(acc.last_bonus_at) : '—' }}</td>
    <!-- ID заказа и сумма начисления -->
    <td>{{ acc.last_bonus_order_id || '—' }}</td>
    <td>{{ acc.last_bonus_amount !== 0 ? '+' + acc.last_bonus_amount : '—' }}</td>

    <!-- Дата последнего списания -->
    <td>{{ acc.last_spend_at ? formatDate(acc.last_spend_at) : '—' }}</td>
    <!-- ID заказа и сумма списания -->
    <td>{{ acc.last_spend_order_id || '—' }}</td>
    <td>{{ acc.last_spend_amount !== 0 ? '-' + acc.last_spend_amount : '—' }}</td>

    <td>{{ acc.mailing_date ? formatDate(acc.mailing_date) : '—' }}</td>
    <td>
      <span v-if="acc.mailing_sent" title="Рассылка произведена">✔️</span>
      <span v-else title="Не отправлено">❌</span>
    </td>
    <td><div class="mes">{{ acc.message || '—' }}</div></td>
    <td v-if="$store.state.user.id === 162">
      <div class="tdEdit">
        <button v-if="editIdx !== idx" @click="startEdit(idx, acc)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"><path fill="#005EEB" fill-rule="evenodd" d="m19.902 3.44.659.658c.28.28.439.66.439 1.058v.758c.005.404-.153.793-.44 1.078l-1.845 1.816a.499.499 0 0 1-.708 0l-2.804-2.844a.499.499 0 0 1 0-.698l1.806-1.827A1.497 1.497 0 0 1 18.087 3h.758c.397 0 .777.158 1.057.44Zm-3.082 7.245a.5.5 0 0 0 0-.699l-2.854-2.814a.499.499 0 0 0-.708 0l-8.052 8.053a1.995 1.995 0 0 0-.449.68l-1.716 4.33a.499.499 0 0 0 .19.62.499.499 0 0 0 .538.109l4.33-1.757c.255-.101.486-.254.679-.449l8.042-8.073Z" clip-rule="evenodd"/></svg></button>
        <button v-else @click="saveEdit(idx, acc)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 14 14"><path fill-rule="evenodd" clip-rule="evenodd" fill="#005EEB" d="M12 11c0 .6-.4 1-1 1h-1V7c0-.6-.4-1-1-1H3c-.5 0-1 .4-1 1v5H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h9l2 2v9zm-2-9c0-.6-.4-1-1-1H3c-.5 0-1 .4-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V2zM8 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM3.7 6.5h4.8c.6 0 1 .4 1 1V11c0 .6-.4 1-1 1h-5c-.6 0-1-.4-1-1V7.5c0-.5.6-1 1.2-1z"/></svg></button>
        <button v-if="editIdx === idx" @click="cancelEdit">✖️</button>
        <button class="btn btn-small btn-clear" style="margin-left:8px" @click="deleteAccount(acc.id)">

        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#f54a4a" width="20" height="20" viewBox="0 0 96 96">
        <path d="m24,78c0,4.968 4.029,9 9,9h30c4.968,0 9-4.032 9-9l6-48h-60l6,48zm33-39h6v39h-6v-39zm-12,0h6v39h-6v-39zm-12,0h6v39h-6v-39zm43.5-21h-19.5c0,0-1.344-6-3-6h-12c-1.659,0-3,6-3,6h-19.5c-2.487,0-4.5,2.013-4.5,4.5s0,4.5 0,4.5h66c0,0 0-2.013 0-4.5s-2.016-4.5-4.5-4.5z"/>
        </svg>
          <!-- 🗑️ -->
        </button>
      </div>
    </td>
  </tr>
  <tr v-if="!accounts.length">
    <td colspan="12">Нет данных</td>
  </tr>
</tbody>

    </table>


    <div :class="{'fixedPagination': !atPageEnd, 'staticPagination': atPageEnd}">

      <b-pagination
        v-if="totalPages > 1"
        v-model="page"
        :per-page="limit"
        :total-rows="total"
        @change="fetchAccounts"
      ></b-pagination>

      <button
        v-if="$store.state.user.id === 162"
        class="btn"
        :disabled="selectedPhones.length === 0"
        @click="openModal"
      >
        Уведомить
      </button>

    </div>

<!-- Модальное окно рассылки -->
<div v-if="showModal" class="modal-mask">
  <div class="modal-wrapper">
    <div class="modal-container">
      <h3>Рассылка уведомлений</h3>
      <p>
        <b>Выбрано номеров:</b> {{ selectedPhones.length }}
      </p>
      <textarea
        v-model="smsText"
        rows="5"
        placeholder="Введите текст. Используйте паттерны: {phone}, {bonus}"
      ></textarea>
      <div style="margin:8px 0;">
        <b>Паттерны:</b>
        <span style="background:#f5f5f5;padding:2px 5px;margin:2px;">{phone}</span>
        <span style="background:#f5f5f5;padding:2px 5px;margin:2px;">{bonus}</span>
      </div>
      <div style="margin-top:15px;text-align:right;">
        <button class="btn" @click="sendSMS" :disabled="sending">
          {{ sending ? "Отправка..." : "Отправить" }}
        </button>
        <button class="btn btn-clear" @click="closeModal" :disabled="sending">Отмена</button>
      </div>
      <div v-if="sendResult" style="margin-top:10px;color:green">{{sendResult}}</div>
    </div>
  </div>
</div>







  </div>
</template>


<script>
import axios from 'axios'
import { over } from 'lodash'
import debounce from 'lodash.debounce'
import DatePicker from 'vue2-datepicker'
import HeaderMain from '@/components/HeaderMain.vue'
import 'vue2-datepicker/index.css'

export default {
  components: { DatePicker, HeaderMain },
  data() {
    return {
      filters: {
        phone: '',
        min_bonus: '',
        max_bonus: '',
        from: null, // дата от
        to: null,    // дата до
        mailing_sent: ''
      },
      sort_by: 'phone',
      showModal: false,
      smsText: 'На ваш номер {phone} начислено {bonus} бонусных баллов',
      sending: false,
      sendResult: '',
      sort_dir: 'asc',
      editIdx: null,
      editData: { phone: '', bonus: 0 },
      accounts: [],
      total: 0,
      page: 1,
      limit: 100,
      selectedPhones: [],
      loading: false,
      atPageEnd: false
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit) || 1
    },
    allSelected() {
      return this.accounts.length && this.selectedPhones.length === this.accounts.length
    },
  },
  watch: {
    limit() {
      this.page = 1
      this.fetchAccounts()
    },
    page() {
      this.fetchAccounts()
    }
  },
  methods: {
    startEdit(idx, acc) {
      this.editIdx = idx;
      this.editData = { id: acc.id, phone: acc.phone, bonus: acc.bonus };
    },
    cancelEdit() {
      this.editIdx = null;
      this.editData = { phone: '', bonus: 0 };
    },
    async saveEdit(idx, acc) {
      // отправляем PATCH или POST запрос на сервер
      try {
        await axios.post('/edit-bonus-account', {
          id: this.editData.id,
          phone: this.editData.phone,
          bonus: this.editData.bonus
        });
        this.editIdx = null;
        this.editData = { phone: '', bonus: 0 };
        this.fetchAccounts();
      } catch (e) {
        alert('Ошибка сохранения');
      }
    },
    // Поиск по кнопке
    search() {
      this.page = 1;
      this.fetchAccounts();
    },
    // Сброс фильтров
    resetFilters() {
      this.filters = {
        phone: '',
        min_bonus: '',
        max_bonus: '',
        from: null,
        to: null
      };
      this.page = 1;
      this.fetchAccounts();
    },

    fetchAccounts() {
      this.loading = true;
      axios.get('/bonus-accounts', {
        params: {
          ...this.filters,
          limit: this.limit,
          page: this.page,
          sort_by: this.sort_by,
          sort_dir: this.sort_dir,
        }
      }).then(res => {
        this.accounts = res.data.accounts
        this.total = res.data.total
      }).catch(() => {
        this.accounts = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },

    async deleteAccount(id) {
      if (!confirm('Удалить запись?')) return;
      try {
        await axios.post('/delete-bonus-account', { id });
        this.fetchAccounts();
      } catch (e) {
        alert('Ошибка удаления!');
      }
    },

    // МОДАЛКА теперь тянет шаблон с сервера!
    async openModal() {
      try {
        const res = await axios.get('/sms-template');
        this.smsText = res.data.template || 'На ваш номер {phone} начислено {bonus} бонусных баллов';
      } catch (e) {
        this.smsText = 'На ваш номер {phone} начислено {bonus} бонусных баллов';
      }
      this.showModal = true;
      this.sendResult = '';
    },
    closeModal() {
      this.showModal = false;
      this.sending = false;
      this.sendResult = '';
    },
    async sendSMS() {
      this.sending = true;
      this.sendResult = '';
      // Сохраняем шаблон перед отправкой (или можно делать чекбокс "Сделать шаблоном по умолчанию")
      try {
        await axios.post('/sms-template', { template: this.smsText });
      } catch (e) {
        // если вдруг не сохранилось — ничего страшного
      }
      // Берём данные по выбранным телефонам
      const selectedAccounts = this.accounts.filter(acc =>
        this.selectedPhones.includes(acc.phone)
      );
      // Массив для отправки
      const messages = selectedAccounts.map(acc => ({
        phone: acc.phone,
        text: this.smsText
          .replace(/{phone}/g, acc.phone)
          .replace(/{bonus}/g, acc.bonus)
      }));

      // Отправка на бекенд одним запросом
      try {
        const { data } = await axios.post('/send-sms-batch', { messages });
        this.sendResult = data.message || 'Успешно отправлено!';
        setTimeout(this.closeModal, 2000);
        this.fetchAccounts(); // обновим список
      } catch (e) {
        this.sendResult = 'Ошибка отправки!';
        this.sending = false;
      }
    },
  
    toggleAll(e) {
      if (e.target.checked) {
        this.selectedPhones = this.accounts.map(acc => acc.phone)
      } else {
        this.selectedPhones = []
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return d.toLocaleString('ru-RU')
    },
    setSort(col) {
      if (this.sort_by === col) {
        this.sort_dir = this.sort_dir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_by = col
        this.sort_dir = 'asc'
      }
      this.fetchAccounts()
    },
    sortIcon(col) {
      if (this.sort_by !== col) return ''
      return this.sort_dir === 'asc' ? 'sort-asc' : 'sort-desc'
    },
    checkScroll() {
      const scrollBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;
      this.atPageEnd = scrollBottom;
    }
  },
  mounted() {
    this.fetchAccounts();
    window.addEventListener("scroll", this.checkScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.checkScroll);
  }
}

</script>

<style scoped>
.input { margin: 0 4px 8px 0; }
.filters { margin-bottom: 10px; }

.modal-mask {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.modal-container {
  background: #fff;
  border-radius: 12px;
  width: 400px;
  max-width: 95vw;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  padding: 28px 24px 20px 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 300px;
}

/* Кнопки */
.btn {
  padding: 10px 50px;
  background: #3390ec;
  color: #fff;
  border: none;
  border-radius: 6px;
  margin-left: 5px;
  cursor: pointer;
  font-weight: 500;
  font-size: 15px;
  transition: background 0.18s;
}
.btn:hover:not(:disabled) {
  background: #2877c8;
}
.btn:disabled {
  background: #a1c2e8;
  cursor: not-allowed;
}
.btn-clear {
  background: #e5e6ea;
  color: #36393f;
}

/* -----------------
Стилизация textarea как bubble телеги
------------------- */
.modal-container textarea {
  width: 100%;
  box-sizing: border-box;
  min-height: 80px;
  max-height: 180px;
  resize: vertical;
  background: #e5eaf1;
  border: none;
  border-radius: 16px 16px 16px 4px;
  padding: 15px 16px;
  font-size: 16px;
  font-family: inherit;
  line-height: 1.6;
  box-shadow: 0 2px 8px rgba(51, 144, 236, 0.06);
  margin-bottom: 6px;
  color: #222;
  outline: none;
  transition: box-shadow 0.2s;
}
.modal-container textarea:focus {
  box-shadow: 0 4px 16px rgba(51, 144, 236, 0.12);
  background: #d2e6fa;
}

/* Чтобы инпуты не вылазили */
.modal-container input,
.modal-container .mx-input {
  max-width: 100%;
  box-sizing: border-box;
}

/* Responsive для мобилок */
@media (max-width: 480px) {
  .modal-container {
    width: 98vw;
    padding: 12px 4vw;
  }
  .modal-container textarea {
    font-size: 15px;
    padding: 11px 8px;
  }
}

.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
  }

  .btn_ms { 
    margin-right: 15px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
  }
  .filters{
    margin-bottom: 25px;
    padding: 20px;
    padding-bottom: 25px;
    background: #fff;
  }

  .blockFlx {
    display: flex;
    margin-bottom: 30px;
    border-bottom: 1px solid #eee;
  }
  
  .blockFlx div {
    display: inline-block;
    float: none;
    width: 100%;
    margin: 20px;
    vertical-align: top;
  }
  .blockFlx div:first-child {
    margin-left: 0;
  }
  .blockFlx input {
    border: 1px solid var(--input-border-color);
    border-radius: var(--input-border-radius);
    box-shadow: var(--input-box-shadow);
    color: var(--input-color);
    font-size: var(--input-font-size);
    height: var(--input-height);
    line-height: var(--input-line-height);
    padding: var(--input-padding);
    transition: var(--input-transition);
    width: 100%;
}
.blockFlx div.mx-datepicker {
  margin-top: 0;
}
.nLabel {
  margin-bottom: 4px;
    display: block;
    font-size: 12px;
    font-style: normal;
    line-height: 1.2;
    padding: 6px 10px 0 0;
    color: #636f7f;
    min-width: 90px;
    max-width: 90px;
    margin-right: 5px;
}
.statRas {
  min-width: 100%;
}

.table {
  --bs-table-color-type: initial;
    --bs-table-bg-type: initial;
    --bs-table-color-state: initial;
    --bs-table-bg-state: initial;
    --bs-table-color: var(--bs-emphasis-color);
    --bs-table-bg: var(--bs-body-bg);
    --bs-table-border-color: var(--bs-border-color);
    --bs-table-accent-bg: transparent;
    --bs-table-striped-color: var(--bs-emphasis-color);
    --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
    --bs-table-active-color: var(--bs-emphasis-color);
    --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
    --bs-table-hover-color: var(--bs-emphasis-color);
    --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
    width: 100%;
    margin-bottom: 1rem;
    vertical-align: top;
    border-color: var(--bs-table-border-color);
    border-collapse: separate;
    border-spacing: 0;
}
.table th {
    color: #636f7f;
    cursor: default;
    font-size: 11px;
    font-weight: 400;
    height: 41px;
    line-height: 12px;
    padding-bottom: 5px;
    padding-top: 6px;
}
.table > thead {
  vertical-align: middle;
}
.table > thead tr th {
  background: #f9fafb;
}
.table .tdEdit {
  display: flex;
}

.btntask {
  background: #f86d6d !important;
}  
.table td {
  font-size: 11px;
  vertical-align: middle;
}
.table > td {
  padding: 5px;
}
.table .btn.btn-small.btn-clear {
  padding: 5px 18px;
}

.table .tdEdit button {
  border: none;
  background: transparent;
  padding: 5px;
  font-size: 13px;
}
.btn.btn-small.btn-clear:hover {
  background: transparent !important;
}

.fixedPagination {
    position: fixed;
    bottom: 0;
    left: 50%;
    right: 50%;
    display: flex;
    justify-content: center;
}

.fixedPagination .btn:hover {
  background: #215282;
  opacity: 1;
}

.staticPagination {
    position: relative;
    display: flex;
    justify-content: center;
    left: 20px;
}

/* .table .mes {
  overflow: hidden;
  height: 20px;
} */
</style>
